import db from '@/js/services/contracts/Database';
import Dexie from 'dexie';

export default {
  // generic add method
  addMasterData(data, tableName, key, localKey) {
    const promise = new Promise((resolve, reject) => {
      const promises = [];
      for (let i = 0; i < data.length; i += 1) {
        const element = data[i];
        // console.log(`Creando promesa para añadir elemento ${JSON.stringify(element)} en la tabla ${tableName}`);
        if (element != null) {
          promises.push(this.addNewMasterData(element, tableName, key, localKey));
        }
      }

      Promise.all(promises).then((result) => {
        resolve(result);
      }).catch((error) => {
        // eslint-disable-next-line no-console
        console.error(`Error al ejecutar las promesas de guardado en la tabla ${tableName} error: ${error}`);
        reject(error);
      });
    });
    return promise;
  },
  async addNewMasterData(element, tableName, key, localKey) {
    const savedElement = await db[tableName].where(key).equals(element[key]).first();
    if (savedElement === undefined) {
      return db[tableName].add(element);
    }
    if (localKey !== undefined) {
      element[localKey] = savedElement[localKey];
    }
    return this.updateMasterData(element, tableName, key, localKey);
  },
  updateMasterData(element, tableName, key, localKey) {
    if (localKey === undefined) {
      return db[tableName].update(element[key], element);
    }
    return db[tableName].update(element[localKey], element);
  },
  removeMasterData(data, tableName, key) {
    const keys = data.map((d) => d[key]).filter((d) => d !== undefined);
    return db[tableName].bulkDelete(keys);
  },
  deleteByProperty(tableName, key, values) {
    return db[tableName].where(key).anyOf(values).delete();
  },
  getAllTableIds(tableName) {
    return db[tableName].toCollection().keys();
  },
  getByKey(tableName, key, value) {
    return db[tableName].where(key).equals(value).toArray();
  },

  // Complementary data
  getAllDcs() {
    return db.dcs.toArray();
  },
  updateDCById(id, updateObj) {
    return db.dcs.update(id, Dexie.deepClone(updateObj));
  },
  getDCByEntity(entity) {
    return db.dcs.where('entity').equals(Number.parseInt(entity, 10)).toArray();
  },
  addDcs(data) {
    // return db.dcs.bulkAdd(data);
    const promise = new Promise((resolve, reject) => {
      const promises = [];
      for (let i = 0; i < data.length; i += 1) {
        const element = data[i];
        promises.push(this.addDc(element));
      }

      Promise.all(promises).then((result) => {
        resolve(result);
      }).catch((error) => {
        reject(error);
      });
    });
    return promise;
  },
  async addDc(dc) {
    const dcsaved = await db.dcs.where('code').equals(dc.code).first();
    if (dcsaved === undefined) {
      return db.dcs.add(Dexie.deepClone(dc));
    }
    return this.updateDCById(dc.code, dc);
  },
  deleteDCById(id) {
    return db.dcs.where('id').equals(id).delete();
  },

  // ownership types
  getAllOwnershipTypes() {
    return db.ownershipTypes.toArray();
  },
  updateOwnershipTypeById(id, updateObj) {
    return db.ownershipTypes.update(id, updateObj);
  },
  getOwnershipTypeById(ids) {
    return db.ownershipTypes.where('id').equals(Number.parseInt(ids, 10)).first();
  },
  addOwnershipTypes(data) {
    // return db.ownershipTypes.bulkAdd(data);
    const promise = new Promise((resolve, reject) => {
      const promises = [];
      for (let i = 0; i < data.length; i += 1) {
        const element = data[i];
        promises.push(this.addOwnershipType(element));
      }

      Promise.all(promises).then((result) => {
        resolve(result);
      }).catch((error) => {
        reject(error);
      });
    });
    return promise;
  },
  async addOwnershipType(element) {
    const dbElement = await db.ownershipTypes.where('id').equals(element.id).first();
    if (dbElement === undefined) {
      return db.ownershipTypes.add(element);
    }
    return this.updateDCById(element.id, element);
  },
  deleteOwnershipTypeById(id) {
    return db.ownershipTypes.where('id').equals(id).delete();
  },

  // QUALITY PROTOCOLS
  getAllProtocols() {
    return db.qprotocols.toArray();
  },
  updateProtocolById(id, updateObj) {
    return db.qprotocols.update(id, updateObj);
  },
  getProtocolById(ids) {
    return db.qprotocols.where('id').equals(Number.parseInt(ids, 10)).first();
  },
  addProtocols(data) {
    // return db.qprotocols.bulkAdd(data);
    const promise = new Promise((resolve, reject) => {
      const promises = [];
      for (let i = 0; i < data.length; i += 1) {
        const element = data[i];
        promises.push(this.addProtocol(element));
      }

      Promise.all(promises).then((result) => {
        resolve(result);
      }).catch((error) => {
        reject(error);
      });
    });
    return promise;
  },
  async addProtocol(element) {
    const dbElement = await db.qprotocols.where('id').equals(element.id).first();
    if (dbElement === undefined) {
      return db.qprotocols.add(element);
    }
    return this.updateDCById(element.id, element);
  },
  deleteProtocolById(id) {
    return db.qprotocols.where('id').equals(id).delete();
  },

  // CAMPAIGNS
  getAllCampaigns() {
    return db.campaign.toArray();
  },
  updateCampaignById(id, updateObj) {
    return db.campaign.update(id, updateObj);
  },
  getCampaignById(ids) {
    return db.campaign.where('id').equals(Number.parseInt(ids, 10)).first();
  },
  addCampaigns(data) {
    // return db.campaign.bulkAdd(data);
    const promise = new Promise((resolve, reject) => {
      const promises = [];
      for (let i = 0; i < data.length; i += 1) {
        const element = data[i];
        promises.push(this.addCampaign(element));
      }

      Promise.all(promises).then((result) => {
        resolve(result);
      }).catch((error) => {
        reject(error);
      });
    });
    return promise;
  },
  async addCampaign(element) {
    const dbElement = await db.campaign.where('id').equals(element.id).first();
    if (dbElement === undefined) {
      return db.campaign.add(element);
    }
    return this.updateDCById(element.id, element);
  },
  deleteCampaignById(id) {
    return db.campaign.where('id').equals(id).delete();
  },

  // VARIETIES
  getAllVarieties() {
    return db.varieties.toArray();
  },
  updateVarietyById(id, updateObj) {
    return db.varieties.update(id, updateObj);
  },
  getVarietyById(ids) {
    return db.varieties.where('id').equals(Number.parseInt(ids, 10)).first();
  },
  addVarieties(data) {
    // return db.varieties.bulkAdd(data);
    const promise = new Promise((resolve, reject) => {
      const promises = [];
      for (let i = 0; i < data.length; i += 1) {
        const element = data[i];
        promises.push(this.addVariety(element));
      }

      Promise.all(promises).then((result) => {
        resolve(result);
      }).catch((error) => {
        reject(error);
      });
    });
    return promise;
  },
  async addVariety(element) {
    const dbElement = await db.varieties.where('id').equals(element.id).first();
    if (dbElement === undefined) {
      return db.varieties.add(element);
    }
    return this.updateDCById(element.id, element);
  },
  deleteVarietyById(id) {
    return db.varieties.where('id').equals(id).delete();
  },

  // COUNTRIES
  getAllCountries() {
    return db.countries.orderBy('name').toArray();
  },
  updateCountryById(id, updateObj) {
    return db.countries.update(id, updateObj);
  },
  getCountryById(ids) {
    return db.countries.where('id').equals(Number.parseInt(ids, 10)).first();
  },
  addCountries(data) {
    return db.countries.bulkAdd(data);
  },
  deleteCountryById(id) {
    return db.countries.where('id').equals(id).delete();
  },

  // FAMILIES OF VARIETIES
  getAllFamilies() {
    return db.familiesOfVarieties.orderBy('name').toArray();
  },
  updateFamilyById(id, updateObj) {
    return db.familiesOfVarieties.update(id, updateObj);
  },
  getFamilyById(ids) {
    return db.familiesOfVarieties.where('id').equals(Number.parseInt(ids, 10)).first();
  },
  addFamilies(data) {
    return db.familiesOfVarieties.bulkAdd(data);
  },
  deleteFamilyById(id) {
    return db.familiesOfVarieties.where('id').equals(id).delete();
  },

  // VAT RATE
  getAllVATRate() {
    return db.vatRate.orderBy('name').toArray();
  },
  updateVATRate(id, updateObj) {
    return db.vatRate.update(id, updateObj);
  },
  getVATRate(ids) {
    return db.vatRate.where('id').equals(Number.parseInt(ids, 10)).first();
  },
  addVATRate(data) {
    return db.vatRate.bulkAdd(data);
  },
  deleteVATRate(id) {
    return db.vatRate.where('id').equals(id).delete();
  },

  // RETENTION
  getAllRetention() {
    return db.retention.orderBy('name').toArray();
  },
  updateRetention(id, updateObj) {
    return db.retention.update(id, updateObj);
  },
  getRetention(ids) {
    return db.retention.where('id').equals(Number.parseInt(ids, 10)).first();
  },
  addRetention(data) {
    return db.retention.bulkAdd(data);
  },
  deleteRetention(id) {
    return db.retention.where('id').equals(id).delete();
  },

  // BUSINESS
  getAllBusiness() {
    return db.business.orderBy('name').toArray();
  },
  updateBusiness(id, updateObj) {
    return db.business.update(id, updateObj);
  },
  getBusiness(ids) {
    return db.business.where('id').equals(Number.parseInt(ids, 10)).first();
  },
  addBusiness(data) {
    return db.business.bulkAdd(data);
  },
  deleteBusiness(id) {
    return db.business.where('id').equals(id).delete();
  },

  // WAY TO PAY
  getAllWayToPay() {
    return db.wayToPay.orderBy('name').toArray();
  },
  updateWayToPay(id, updateObj) {
    return db.wayToPay.update(id, updateObj);
  },
  getWayToPay(ids) {
    return db.wayToPay.where('id').equals(Number.parseInt(ids, 10)).first();
  },
  addWayToPay(data) {
    return db.wayToPay.bulkAdd(data);
  },
  deleteWayToPay(id) {
    return db.wayToPay.where('id').equals(id).delete();
  },
  // Zones
  getAllZones() {
    return db.zones.orderBy('name').toArray();
  },
  updateZones(id, updateObj) {
    return db.zones.update(id, updateObj);
  },
  getZones(ids) {
    return db.zones.where('id').equals(Number.parseInt(ids, 10)).first();
  },
  addZones(data) {
    return db.zones.bulkAdd(data);
  },
  deleteZones(id) {
    return db.zones.where('id').equals(id).delete();
  },
};
